// src/pages/History/RenaissanceReformation/ProtestantReformationGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Renaissance_&_Reformation_-_Protestant_Reformation.png';

export default function HistoryPageProtestantReformationGo() {
  return (
    <QuizPage
      title="History: Protestant Reformation"
      subTopic="Protestant Reformation"
      backgroundImage={historyImage}
      returnPath="/History-Protestant-Reformation"
    />
  );
}
